export const messages = {
  en: {
    assetImportLog: {
      title: 'Batch Import Log',
      logId: 'Import ID',
      logTypeName: 'Import Type',
      waitCount: 'Pending Count',
      successCount: 'Success Count',
      errorCount: 'Failed Count',
      state: 'Status',
      stateW: 'Pending',
      stateC: 'Completed',
      stateP: 'Processing',
      createTime: 'Import Time',
      remark: 'Remark',
      fetchError: 'Failed to fetch import logs'
    }
  },
  zh: {
    assetImportLog: {
      title: '批量导入日志',
      logId: '导入编号',
      logTypeName: '导入类型',
      waitCount: '待导入数',
      successCount: '成功数量',
      errorCount: '失败数量',
      state: '状态',
      stateW: '待导入',
      stateC: '已完成',
      stateP: '处理中',
      createTime: '导入时间',
      remark: '备注',
      fetchError: '获取导入日志失败'
    }
  }
}